import axios from "axios";
import {
  clearLocalStorageData,
  getLocalStorageData,
  setLocalStorageData,
} from "./shared/utils/localStorage";
import { formatAxiosError } from "./shared/utils/errorHandler";

// create an axios instance
const service = axios.create({
  baseURL: process.env.REACT_APP_API_URL, // url = base url + request url
  timeout: 15000, // request timeout
});

// request interceptor do something before request is sent
service.interceptors.request.use(
  (config: any) => {
    // console.log("success", getLocalStorageData("token"));
    const fullUrl = `${config.baseURL || ""}${config.url || ""}`;

    if (!config.headers.hasOwnProperty("Authorization")) {
      let token;

      // if (fullUrl.includes("global-admin")) {
      //   token = getLocalStorageData("global_token");
      // } else {
      token = getLocalStorageData("token");
      // }
      // const token =
      //   "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjEiLCJ1c2VyVHlwZSI6IkFkbWluIiwiaWF0IjoxNzE1MDc3NzA3LCJleHAiOjE3MTUwOTU3MDd9.LnySj57DureKTglhgEGBcAuvMCWvBjDh3Klr5J-DXUQ";

      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }
    if (config.data instanceof FormData) {
      config.headers["content-type"] = "multipart/form-data";
    } else {
      config.headers["content-type"] = "application/json";
    }
    config.headers["Accept"] = "application/json";
    // ------For Admin and Client
    config.headers["x-sourceName"] = process.env.REACT_APP_USER_TYPE;

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// response interceptor
service.interceptors.response.use(
  (response) => {
    const localStorageToken = getLocalStorageData("token");
    // const fullUrl = `${response.config.baseURL || ""}${
    //   response.config.url || ""
    // }`;
    const headerToken = response.headers?.token;

    if (
      response.headers?.token &&
      response.headers?.token !== undefined &&
      response.headers?.token !== "undefined" &&
      response.headers?.token !== localStorageToken
    ) {
      // if (fullUrl.includes("global-admin")) {
      //   setLocalStorageData("global_token", headerToken);
      // } else {
      setLocalStorageData("token", headerToken);
      // }
    }
    return response;
  },
  (error) => {
    // Network error or timeout
    if (!error.response) {
      const msg = error.message.includes("timeout")
        ? "Server is taking too long to respond. Please try again later."
        : "Network error. Please check your internet connection.";
      return Promise.reject({
        message: msg,
        type: "network",
        statusCode: 0,
        data: {},
      });
    }
    if (error?.response?.status === 401) {
      // alert("Session Expired");
      clearLocalStorageData();
      // window.location.href = "/login";
      window.location.replace(`/login`);
    }
    const formattedError = formatAxiosError(error?.response?.data);
    return Promise.reject(formattedError);
  }
);

export default service;
